
import { IonItem, IonList, IonLabel, IonChip } from '@ionic/react';
import React from 'react'
import Page from '../components/Page';
import grailItems from '../data/grailItems';

export default class extends React.Component {

  constructor(props) {
    super(props);
    if(!localStorage.getItem('uniqueItemsFound')) localStorage.setItem('uniqueItemsFound', JSON.stringify([]));
    if(!localStorage.getItem('setItemsFound')) localStorage.setItem('setItemsFound', JSON.stringify([]));
  }

  render() {
    const uniqueItems = Object.values(grailItems.uniqueItems).length
    const uniqueItemsFound = JSON.parse(localStorage.getItem('uniqueItemsFound')).length
    const setItems = Object.values(grailItems.setItems).length
    const setItemsFound = JSON.parse(localStorage.getItem('setItemsFound')).length
    return (
      <Page title="Holy Grail Overview" large>
        <IonList>
        <IonItem routerLink="/grail/Unique Items">
            <IonLabel >
              <h1>Unique Items</h1>
              <p>{uniqueItemsFound} out of {uniqueItems} found</p>
            </IonLabel>
            <IonChip>{Math.round(1000*uniqueItemsFound/uniqueItems)/10} %</IonChip>
          </IonItem>
          <IonItem routerLink="/grail/Set Items">
            <IonLabel >
              <h1>Set Items</h1>
              <p>{setItemsFound} out of {setItems} found</p>
            </IonLabel>
            <IonChip>{Math.round(1000*setItemsFound/setItems)/10} %</IonChip>
          </IonItem>
        </IonList>
      </Page>
    );
  }
}